import { getCompanyInfo } from '@/plugins/helpers'

import layoutAdmin from "@/layouts/layoutAdmin.vue";
import addSalesTeam from "@/views/module/sales/targetManagement/addSalesTeam.vue";
import addLead from "@/views/module/sales/crmManagement/addLead.vue";
import addProposal from "@/views/module/sales/crmManagement/addProposal.vue";
import leadRecord from "@/views/module/sales/crmManagement/leadRecord.vue";
import leadDetailsView from "@/views/module/sales/crmManagement/leadDetailsView.vue";
import proposalRecord from "@/views/module/sales/crmManagement/proposalRecord.vue";
import workOrders from "@/views/module/sales/crmManagement/workOrders.vue";
import saleOrder from "@/views/module/sales/orderManagement/saleOrder.vue";
import saleOrderRecord from "@/views/module/sales/orderManagement/saleOrderRecord.vue";
import viewOrderInvoice from "@/views/module/sales/orderManagement/viewOrderInvoice.vue";
import viewOrderInvoice_textech from "@/views/module/sales/orderManagement/viewOrderInvoice_textech.vue";
import contactRecord from "@/views/module/sales/crmManagement/contactRecord.vue";
import addContact from "@/views/module/sales/crmManagement/addContact.vue";
import viewProposalInvoice from "@/views/module/sales/crmManagement/viewProposalInvoice.vue";
import proposalDetailsView from "@/views/module/sales/crmManagement/proposalDetailsView.vue";
import workOrderDetailsView from "@/views/module/sales/crmManagement/workOrderDetailsView.vue";
import customerSetup from "@/views/module/inventory/customerManagement/customerSetup.vue";
import customerList from "@/views/module/inventory/customerManagement/customerList.vue";
import letterSetup from "@/views/module/sales/setttingsManagement/letterSetup.vue";
import saleInvoice from "@/views/module/sales/orderManagement/saleInvoice.vue";
import saleInvoiceRecord from "@/views/module/sales/orderManagement/saleInvoiceRecord.vue";
import viewSaleInvoice from "@/views/module/sales/orderManagement/viewSaleInvoice.vue";
import viewSaleInvoice_textech from '@/views/module/sales/orderManagement/viewSaleInvoice_textech.vue';
import saleCollectionRecord from "@/views/module/sales/orderManagement/saleCollectionRecord.vue";
import salesTeamRecord from "@/views/module/sales/targetManagement/SalesTeamRecord.vue";
import addSalesDepartmentTarget from "@/views/module/sales/targetManagement/addSalesDepartmentTarget.vue";
import salesDepartmentTargetRecords from "@/views/module/sales/targetManagement/salesDepartmentTargetRecords.vue";
import addSalesTeamTarget from "@/views/module/sales/targetManagement/addSalesTeamTarget.vue";
import salesTeamTargetRecords from "@/views/module/sales/targetManagement/salesTeamTargetRecords.vue";
import addSalesEmployeeTarget from "@/views/module/sales/targetManagement/addSalesEmployeeTarget.vue";
import salesEmployeeTargetRecords from "@/views/module/sales/targetManagement/salesEmployeeTargetRecords.vue";
import salesFixedPercentageCommisionSetup from "@/views/module/sales/commissionSettingsManagement/salesFixedPercentageCommisionSetup.vue";
import salesPieredCommissionSetup from "@/views/module/sales/commissionSettingsManagement/salesTieredCommissionSetup.vue";
import salesProductBasedCommissionSetup from "@/views/module/sales/commissionSettingsManagement/salesProductBasedCommissionSetup.vue";
import salesProfitBasedCommission from "@/views/module/sales/commissionSettingsManagement/salesProfitBasedCommission.vue";
// Reports
import salesStatementReports from "@/views/module/sales/reports/salesStatementReports.vue";
import customerSalesReports from "@/views/module/sales/reports/customerSalesReports.vue";
import customerSalesOrderReport from "@/views/module/sales/reports/customerSalesOrderReports.vue";
import employeeSalesSummeryReport from "@/views/module/sales/reports/employeeSalesSummeryReports.vue";
import employeeSalesDetailsReport from "@/views/module/sales/reports/employeeSalesDetailsReports.vue";
import salesTargetVsActualReport from "@/views/module/sales/reports/salesTargetVsActualReport.vue";
import commissionReport from "@/views/module/sales/reports/commissionReports.vue";

export default [
    {
        path: "/sales",
        component: layoutAdmin,

        meta: {
            UserLoggedIn: true,
            breadcrumb: "Sales Management",
        },

        children: [
            {
                path: "add-sales-team",
                name: "add-sales-team",
                meta: {
                    breadcrumb: ["Sales Team Setup"],
                },
                component: addSalesTeam,
            },  
            {
                path: "sales-team-list",
                name: "sales-team-list",
                meta: {
                    breadcrumb: ["Sales Team Record"],
                },
                component: salesTeamRecord,
            },  
            {
                path: "add-deparment-target",
                name: "add-deparment-target",
                meta: {
                    breadcrumb: ["Add Department Target"],
                },
                component: addSalesDepartmentTarget,
            },  
            {
                path: "department-target-records",
                name: "department-target-records",
                meta: {
                    breadcrumb: ["Department Target"],
                },
                component: salesDepartmentTargetRecords,
            },  
            {
                path: "add-team-target",
                name: "add-team-target",
                meta: {
                    breadcrumb: ["Team Target"],
                },
                component: addSalesTeamTarget,
            },  
            {
                path: "team-target-records",
                name: "team-target-records",
                meta: {
                    breadcrumb: ["Team Target Records"],
                },
                component: salesTeamTargetRecords,
            },  
            {
                path: "add-employee-target",
                name: "add-employee-target",
                meta: {
                    breadcrumb: ["Employee Target Records"],
                },
                component: addSalesEmployeeTarget,
            },  
            {
                path: "employee-target-records",
                name: "employee-target-records",
                meta: {
                    breadcrumb: ["Employee Target Records"],
                },
                component: salesEmployeeTargetRecords,
            },  
            {
                path: "add-crm-lead",
                name: "add-crm-lead",
                meta: {
                    breadcrumb: ["Lead Setup"],
                },
                component: addLead,
            },
            {
                path: "letter-setup",
                name: "letter-setup",
                meta: {
                    breadcrumb: ["Lead Setup"],
                },
                component: letterSetup,
            },
            {
                path: "crm-lead-record",
                meta: {
                    breadcrumb: ["Lead Record"],
                },
                component: leadRecord,
            },  
            {
                path: "add-crm-proposal",
                name: "add-crm-proposal",
                meta: {
                    breadcrumb: ["Proposal Setup"],
                },
                component: addProposal,
            },
            {
                path: "crm-view-lead/:id",
                name: "crm-view-lead",
                meta: {
                    breadcrumb: ["Lead details"],
                },
                component: leadDetailsView,
            },
            {
                path: "crm-proposal-record",
                name: "crm-proposal-record",
                meta: {
                    breadcrumb: ["Proposal Record"]
                },
                component: proposalRecord
            },
            {
                path: "crm-view-proposal/:id",
                name: "crm-view-proposal",
                meta: {
                    breadcrumb: ["Proposal details"]
                },
                component: proposalDetailsView
            },
            {
                path: "view-proposal-invoice/:id",
                name: "view-proposal-invoice",
                meta: {
                    breadcrumb: ['Proposal Record', 'View Proposal Invoice']
                },
                component: viewProposalInvoice,
            },
            {
                path:"crm-work-order",
                name: "crm-work-order",
                meta: {
                    breadcrumb: [""]
                },
                component: workOrders
            },
            {
                path:"crm-view-work-order/:id",
                name: "crm-view-work-order",
                meta: {
                    breadcrumb: [""]
                },
                component: workOrderDetailsView
            }
            ,
            {
                path: "add-sale-order",
                name: "add-sale-order",
                meta: { breadcrumb: ["Sale Order"] },
                component: saleOrder,
            },
            {
                path: "sale-order-record",
                name: "sale-order-record",
                meta: { breadcrumb: ["Sale Order Record"] },
                component: saleOrderRecord,
            },

            {
                path: "view-order-invoice/:id",
                name: "view-order-invoice",
                meta: {
                    breadcrumb: ["Order Invoice"],
                },
                component: () => {
                const companyInfo = getCompanyInfo();
                    if (companyInfo.id === 6) {
                        return viewOrderInvoice_textech;
                    }
        
                    return viewOrderInvoice
                },
            },

            {
                path: "add-crm-contract",
                name: "add-crm-contract",
                meta: { breadcrumb: ["Contact Setup"] },
                component: addContact,
            },
            {
                path: "crm-contract-record",
                name: "crm-contract-record",
                meta: { breadcrumb: ["Contact Record"] },
                component: contactRecord,
            },
            {
                path: "customer-setup",
                name: "customer-setup",
                meta: { breadcrumb: ["Add Customer"] },
                component: customerSetup,
            },
            {
                path: "customer-record",
                name: "customer-record",
                meta: { breadcrumb: ["Customer Record"] },
                component: customerList,
            },
            {
                path: "add-sale-invoice",
                name: "add-sale-invoice",
                meta: { breadcrumb: ["Sale Order Invoice"] },
                component: saleInvoice,
            },
            {
                path: "sale-invoice-record",
                name: "sale-invoice-record",
                meta: { breadcrumb: ["Sale Invoice Record"] },
                component: saleInvoiceRecord,
            },
            {
                path: "view-sale-invoice/:id",
                name: "view-sale-invoice",
                meta: {
                    breadcrumb: ["sale Invoice"],
                },
                component: () => {
                    const companyInfo = getCompanyInfo();
                    if (companyInfo.id === 6) {
                        return viewSaleInvoice_textech;
                    }

                    return viewSaleInvoice;
                },
            },
            {
                path: "sale-collection-record",
                name: "sale-collection-record",
                meta: { breadcrumb: ["Sale Collection Record"] },
                component: saleCollectionRecord,
            },

            {
                path: "fixed-percentage-commission",
                name: "fixed-percentage-commission",
                meta: { breadcrumb: ["Sale Fixed Percentage Commission"] },
                component: salesFixedPercentageCommisionSetup,
            },
            {
                path: "tiered-commission",
                name: "tiered-commission",
                meta: { breadcrumb: ["Tiered Commission"] },
                component: salesPieredCommissionSetup,
            },
            {
                path: "product-based-commission",
                name: "product-based-commission",
                meta: { breadcrumb: ["Product Based Commission"] },
                component: salesProductBasedCommissionSetup,
            },
            {
                path: "profit-based-commission",
                name: "profit-based-commission",
                meta: { breadcrumb: ["Profit Based Commission"] },
                component: salesProfitBasedCommission,
            },
            // report
            {
                path: "sales-statement-report",
                name: "sales-statement-report",
                meta: { breadcrumb: ["Sales Statement Reports"] },
                component: salesStatementReports,
            },
            {
                path: "customer-sales-report",
                name: "customer-sales-report",
                meta: { breadcrumb: ["Customer Sales Reports"] },
                component: customerSalesReports,
            },
            {
                path: "sales-orders-report",
                name: "sales-orders-report",
                meta: { breadcrumb: ["Customer Sales Order Reports"] },
                component: customerSalesOrderReport,
            },
            {
                path: "employee-sales-summery-report",
                name: "employee-sales-summery-report",
                meta: { breadcrumb: ["Employee Sales Summery Report"] },
                component: employeeSalesSummeryReport,
            },
            {
                path: "employee-sales-details-report",
                name: "employee-sales-details-report",
                meta: { breadcrumb: ["Employee Sales Details Report"] },
                component: employeeSalesDetailsReport,
            },
            {
                path: "sales-target-vs-actual-report",
                name: "sales-target-vs-actual-report",
                meta: { breadcrumb: ["Sales Target Vs Actual Report"] },
                component: salesTargetVsActualReport,
            },

            {
                path: "commission-report",
                name: "commission-report",
                meta: { breadcrumb: ["Commission Report"] },
                component: commissionReport,
            },

        ],
    },
];
